function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0029 33.4887H4.39766C2.33626 33.4887 0.687134 31.8033 0.687134 29.6966V18.6011C0.687134 16.4944 2.33626 14.809 4.39766 14.809H14.5673",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6696 14.809H42.6023C44.6637 14.809 46.3129 16.4944 46.3129 18.6011V29.6966C46.3129 31.8033 44.6637 33.4887 42.6023 33.4887H29.5468",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.89471 14.809V33.4887",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.84796 29.2753H6.87135",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8275 23.236L15.9416 26.1854",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2661 26.1854L36.1433 21.9719L32.1579 26.1854L30.6462 24.6405",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6374 31.2416C22.538 31.2416 21.576 32.2247 21.576 33.3483C21.576 34.4719 22.538 35.4551 23.6374 35.4551C24.7368 35.4551 25.6988 34.4719 25.6988 33.3483C25.8362 32.2247 24.8742 31.2416 23.6374 31.2416Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9123 12C21.576 12 19.1023 13.1236 18.0029 15.6517C17.4532 16.9157 18.4152 18.3202 19.7895 18.3202C20.4766 18.3202 21.1637 17.8989 21.4386 17.1966C21.8509 16.2135 22.8129 15.7921 23.7749 15.7921C25.1491 15.7921 26.2485 16.7753 26.2485 18.3202C26.2485 19.7247 25.424 20.427 24.3246 21.1292C23.0877 22.1124 21.576 23.0955 21.576 26.0449V26.3258C21.576 27.4494 22.4006 28.2921 23.5 28.2921C24.5994 28.2921 25.424 27.4494 25.424 26.3258V26.0449C25.424 24.6405 26.386 23.7978 27.348 23.0955C28.8597 21.8315 30.2339 20.7079 30.2339 18.1798C30.2339 14.2472 27.2105 12 23.9123 12Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgLicensePlateNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlateNotFound);
export default __webpack_public_path__ + "static/media/license-plate-not-found.8cce4ef3e739df1cd6a4811542d50f35.svg";
export { ForwardRef as ReactComponent };